import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExclamationTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 29"
    {...props}
  >
    <path
      fill="#F4AC3F"
      d="M13.89 12.186c0-.37.264-.686.633-.686h2.9c.37 0 .634.316.634.685l-.37 5.907c0 .316-.316.58-.632.58h-2.162c-.37 0-.633-.211-.633-.58zm4.325 9.439A2.194 2.194 0 0 1 16 23.84c-1.266 0-2.215-.95-2.215-2.215 0-1.213.95-2.215 2.215-2.215a2.23 2.23 0 0 1 2.215 2.215m-.053-18.984 12.656 21.99c.95 1.687-.263 3.744-2.215 3.744H3.343c-1.95 0-3.163-2.11-2.214-3.744L13.785 2.64c.95-1.688 3.428-1.635 4.377 0M3.607 25.42c-.158.212 0 .423.264.423h24.205c.264 0 .422-.211.264-.422L16.264 4.434c-.159-.211-.422-.211-.58 0z"
    />
  </svg>
);
export default SvgExclamationTriangle;
